<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="480"
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="导出卡明细"
      ok-text="导出"
      @ok="handleSubmit"
    >
      <a-form class="simiot-compact-form" :form="form" @submit="handleSubmit">
        <a-form-item label="附加导出列">
          <a-checkbox v-model="includeReceiveAddress">邮寄地址</a-checkbox>
          <a-checkbox v-model="includeExpressNo">快递单号</a-checkbox>
        </a-form-item>
        <div class="export-options-tip">默认不导出上述列，勾选后才会写入 Excel。</div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AgentSimCardExportOptions',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'agent_sim_cards_export_options' }),
      includeReceiveAddress: false,
      includeExpressNo: false,
      submitting: false
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    handleSubmit(e) {
      if (e && e.preventDefault) {
        e.preventDefault()
      }
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交'
        })
        return
      }
      this.submitting = true
      this.$emit('completed', {
        includeReceiveAddress: this.includeReceiveAddress,
        includeExpressNo: this.includeExpressNo
      })
      this.isShow = false
      this.submitting = false
    }
  }
}
</script>

<style scoped>
.export-options-tip {
  color: rgba(0, 0, 0, 0.45);
  font-size: 12px;
  line-height: 1.5;
  margin-top: -8px;
}
</style>
